
import casino_json from "../_asset/media/list_casino.json"

// import e1 from "../_asset/casino/evolution_casino.png"
// import mg from "../_asset/casino/microgaming_casino.png"
// import pp from "../_asset/casino/pragmatic_casino.png"
// import ag from "../_asset/casino/ag_casino.png"
// import dg from "../_asset/casino/dreamgaming_casino.png"
// import wm from "../_asset/casino/wm_casino.png"
// import bt from "../_asset/casino/bota_casino1.png"
// import dw from "../_asset/casino/duwon_casino.png"
// import vv from "../_asset/casino/vivo_casino.png"
import e1 from "../_asset/casino/new/evolution_casino.png"
import mg from "../_asset/casino/new/microgaming_casino.png"
import pp from "../_asset/casino/new/pragmatic_casino.png"
import ag from "../_asset/casino/new/ag_casino.png"
import dg from "../_asset/casino/new/dreamgaming_casino.png"
import wm from "../_asset/casino/new/wm_casino.png"
import bt from "../_asset/casino/new/bota_casino1.png"
import dw from "../_asset/casino/new/duwon_casino.png"
import vv from "../_asset/casino/new/vivo_casino.png"
import mojos_img from "../_asset/casino/new/7-mojos.png"
import absolutegames_img from "../_asset/casino/new/absolute.png"
import skywind_img from "../_asset/casino/new/Skywind Live.png"
import betgamestv_img from "../_asset/casino/new/Betgames.tv.png"
import ezugi_img from "../_asset/casino/new/ezugi.png"
import onetouch_live_img from "../_asset/casino/new/onetouch-live.png"
// import sexybcrt_img from "../_asset/casino/new/sexybcrt.png"
import sexybcrt_img from "../_asset/casino/new/sexybcrt2.jpg"

import e1_logo from "../_asset/casino/logo/EG.png"
import mg_logo from "../_asset/casino/logo/MicroGaming_logo.png"
import pp_logo from "../_asset/casino/logo/PragmaticPlay_logo.png"
import ag_logo from "../_asset/casino/logo/AG.png"
import dg_logo from "../_asset/casino/logo/DreamGame_logo.png"
import wm_logo from "../_asset/casino/logo/WM Live_logo.png"
import bt_logo from "../_asset/casino/logo/bota_logo.png"
import dw_logo from "../_asset/casino/logo/Dowin_logo.png"
import vv_logo from "../_asset/casino/logo/vivo_logo.png"
import betgametv_logo from "../_asset/casino/logo/betgametv.png"
import skywind_logo from "../_asset/casino/logo/skywind.png"
import ezugi_logo from "../_asset/casino/logo/ezugi.png"
import mojos_logo from "../_asset/casino/logo/7mojos.png"
import absolute_logo from "../_asset/casino/logo/absolutegames.png"
import onetouch_logo from "../_asset/casino/logo/onetouch.png"
import sexybcrt_logo from "../_asset/casino/logo/sexybcrt.png"
import PlayTech_logo from "../_asset/casino/logo/playtechlogo.png"
import MGGrand_logo from "../_asset/casino/logo/MGGRANDLOGO1.png"

export type GameCompanyListType = 'evolution' | 'evolution I' | 'PragmaticPlay Live' | 'MicroGaming Plus' | 'Asia Gaming'
    | 'DreamGame' | 'WM Live' | 'vivo'
    | '7-mojos'
    | 'absolute'
    | 'onetouch'
    | 'Skywind Live'
    | 'Betgames.tv'
    | 'ezugi'
    | 'bota'
    | 'sexybcrt'
    | 'PlayTech'
    | 'MicroGaming'
export interface CasinoImageInterface {
    id: string,
    name: string,
    vendor: GameCompanyListType,
    img: string,
    logo: string,
}
export const compL_casino = {
    "evolution": {
        img: e1,
        logo: e1_logo
    },
    "PragmaticPlay Live": {
        img: pp,
        logo: pp_logo
    },
    "MicroGaming Plus": {
        img: mg,
        logo: mg_logo
    },
    "Asia Gaming": {
        img: ag,
        logo: ag_logo
    },
    'DreamGame': {
        img: dg,
        logo: dg_logo
    },
    'WM Live': {
        img: wm,
        logo: wm_logo
    },
    'vivo': {
        img: vv,
        logo: vv_logo
    },
    '7-mojos': {
        img: mojos_img,
        logo: mojos_logo
    },
    'absolute': {
        img: absolutegames_img,
        logo: absolute_logo

    },
    'Skywind Live': {
        img: skywind_img,
        logo: skywind_logo
    },
    'Betgames.tv': {
        img: betgamestv_img,
        logo: betgametv_logo
    },
    'ezugi': {
        img: ezugi_img,
        logo: ezugi_logo
    },
    'bota': {
        img: bt,
        logo: bt_logo
    },
    'onetouch': {
        img: onetouch_live_img,
        logo: onetouch_logo
    },
    'sexybcrt': {
        img: sexybcrt_img,
        logo: sexybcrt_logo
    },
    'PlayTech': {
        img: sexybcrt_img,
        logo: PlayTech_logo
    },
    'MicroGaming': {
        img: ezugi_img,
        logo: MGGrand_logo
    },
}
const newJson = []
for (let comp of casino_json) {
    //@ts-ignore
    const vendorImageInfo = compL_casino[comp.vendor as GameCompanyListType]
    if (vendorImageInfo) {
        const vendorObj: CasinoImageInterface = {
            id: comp.id,
            name: comp.title,
            vendor: comp.vendor as GameCompanyListType,
            img: vendorImageInfo?.img || "",
            logo: vendorImageInfo?.logo || ""
        }
        newJson.push(vendorObj)
    }
}
export const exportNewCasinoJson = newJson
export const sexyVendor = newJson.find((val) => val.vendor == 'sexybcrt')

// 아너링크 제외
export const otherCasino = ['Betgames.tv',
    'Skywind Live',
    '7-mojos',
    'absolute',
    'sexybcrt',
    'onetouch',]